module.exports = __webpack_public_path__ + "static/media/contact.4f6effa9.webp";